import {ConversationChannel} from "../../../api/generated";

export const FEEDBACK_SOURCE = "feedbacks";

interface TranscriptTarget {
    publicBotId: string;
    userId: number;
    conversationChannel: ConversationChannel;
}

const buildLink = (target: TranscriptTarget, focus: Record<string, number>) => {
    const params = new URLSearchParams({
        conversationChannel: target.conversationChannel,
        ...Object.fromEntries(Object.entries(focus).map(([key, value]) => [key, String(value)])),
        from: FEEDBACK_SOURCE,
    });
    return `/transcripts/${target.publicBotId}/${target.userId}?${params.toString()}`;
};

export const messageFeedbackTranscriptLink = (target: TranscriptTarget, chatHistoryId: number) =>
    buildLink(target, {message: chatHistoryId});

export const surveyTranscriptLink = (target: TranscriptTarget, surveyId: number) =>
    buildLink(target, {survey: surveyId});
